// API configuration
const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:5000';
const isDevelopment = import.meta.env.MODE === 'development';

export const fetchApi = async (endpoint, options = {}) => {
  const defaultOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    mode: 'cors'
  };

  const fetchOptions = {
    ...defaultOptions,
    ...options,
    headers: {
      ...defaultOptions.headers,
      ...options.headers
    }
  };

  // In development, use the full URL with apiUrl
  // In production, use relative paths (Nginx handles routing)
  const url = isDevelopment
    ? `${apiUrl}/api${endpoint}`.replace(/([^:]\/)\/+/g, "$1")
    : `/api${endpoint}`;
  console.log('Making API call to:', url, fetchOptions);
  
  try {
    const response = await fetch(url, fetchOptions);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
};

export const API_ENDPOINTS = {
  events: '/events',
  artists: '/artists',
  releases: '/releases',
  upcomingEvents: '/upcoming-events',
  pastEvents: '/past-events',
  debug: '/debug',
  checkTwitchStreams: '/check-twitch-streams',
  main: '/main'
};

export default fetchApi;
